import styled from 'styled-components'
import { Close } from 'svgIcons'
import {
  GqlExamRestoredQuestionKeywordsDocument,
  useGqlDeleteExamQuestionKeywordMutation,
} from 'generated/graphql'

interface KeywordItemProps {
  id: string
  label: string
  isAdmin?: boolean
}

const KeywordItem = ({ id, label, isAdmin }: KeywordItemProps) => {
  const [deleteKeywordMutation] = useGqlDeleteExamQuestionKeywordMutation({
    refetchQueries: [GqlExamRestoredQuestionKeywordsDocument],
    onCompleted: () => {
      alert('키워드가 삭제되었습니다.')
    },
  })

  const handleDeleteKeyword = async () => {
    if (confirm('해당 키워드를 삭제하시겠습니까?')) {
      deleteKeywordMutation({ variables: { deleteExamQuestionKeywordId: id } })
    }
  }

  return (
    <StyledWrapper>
      <span>{label}</span>
      {isAdmin && (
        <i onClick={handleDeleteKeyword}>
          <Close />
        </i>
      )}
    </StyledWrapper>
  )
}

export default KeywordItem

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 15px;
  height: 40px;
  border-radius: 5px;
  border: solid 1px #d9e9f3;
  background-color: #f2faff;
  gap: 7px;
  > span {
    font-size: 12px;
    font-weight: normal;
    letter-spacing: -0.48px;
    color: #333;
  }

  > i {
    padding: 4px;
    cursor: pointer;
    > svg {
      display: block;
      width: 10px;
      height: 10px;
    }
  }
`
